import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow, LinearProgress

} from '@material-ui/core';

import {coreStyle, EnhancedTableHead} from "../../../styles/config";
import {parseQueryParams} from "../../../utils/helpers";
import Resource from "../../../crud/resource";
import ReportSearch from "../../../widgets/ReportSearch";
import axios from "axios";
import Swal from "sweetalert2";
import {Link} from "react-router-dom";
import EmailContact from "../email";
import {useSelector} from "react-redux";
import Translate from "../../../utils/utils";

const headCells = [
    {id: 'buyer', label: <Translate id="TABLE.BUYER"/>},
    {id: 'shipment_date', label: <Translate id="TABLE.SHIPMENT_DATE"/>},
    {id: 'shipments', label: <Translate id="TABLE.SHIPMENTS"/>},
    {id: 'emails_sent', label: <Translate id="TABLE.EMAILS_SENT"/>},
    {id: 'actions', label: <Translate id="TABLE.ACTIONS"/>},

];

export default function BuyerFlowerOrders(props) {
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const [date, setDate] = React.useState(queryParams.date);
    const perPage = queryParams.perPage;
    const [inspections, setInspections] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState(queryParams.name);
    const [downloads, setDownloads] = useState([]);
    const reportResource = new Resource('flowerBuyerReport');
    const [initialValues, setInitialValues] = useState({});
    const user = useSelector(store => store.auth.user);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });
    const getDownloadLink = (inspection, shippingDate) => {
        const time = new Date().getTime();
        const downloading = [...downloads];
        downloading.push(time);
        setDownloads([...downloading]);
        axios.get(`${process.env.REACT_APP_API_BASE_TEST}/report/flower/buyer?buyerId=${inspection.buyer_id}&shippingDate=${shippingDate}&download=true`, {
            responseType: 'arraybuffer',
        }).then(response => {
            const {data} = response;
            const url = URL.createObjectURL(new Blob([data], {
                type: "application/pdf"
            }));
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = url;
            a.download = `${inspection.buyer_name}_${shippingDate}.pdf`
            a.click();
            window.URL.revokeObjectURL(url);
            setDownloads(downloading.filter(t => t !== time));

        }).catch(() => {
            setDownloads(downloading.filter(t => t !== time));
            Swal.fire({
                icon: 'error',
                text: 'Failed downloading report'
            });
        })
    }

    useEffect(() => {

        const list = () => {
            setIsLoading(true);
            const resource = new Resource('flowerShipment/buyer');
            resource.index({
                perPage,
                page,
                name,
                date
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setInspections(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            });
        };
        list()
    }, [page, perPage]);


    const handleNameChange = (name) => {
        setName(name);
    }

    const handleDateChange = (date) => {
        setDate(date);
    }
    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}&date=${date}`);
    };

    const openModal = (inspection) => {
        const to = [];
        to.push(inspection?.buyer_email ||'');
        to.push(inspection?.inspector?.email || '');

        setInitialValues({
            inspection_id: inspection.buyer_id,
            buyer_id: inspection?.buyer_id,
            account_name: inspection?.buyer_name,
            shipping_date: inspection?.shipping_date,
            language_id: user.language_id,
            to: to.filter((email) => email !== null && email.indexOf('@') > 0),
            cc: [],
            type: <Translate id="TABLE.BUYER"/>
        });

    };

    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`?page=${page}&perPage=${perPage}&name=${name}&date=${date}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&name=${name}&date=${date}`);
    };
    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">

            </div>

            <ReportSearch handleNameChange={handleNameChange} handleDateChange={handleDateChange} onSubmit={onSearch}
                          module={"Buyer"} onClear={onClearSearch} value={queryParams.name} dateTerm={queryParams.date}
                          disabled={isLoading}/>
            {(isLoading || downloads.length > 0) && <LinearProgress color="secondary"/>}
            <Paper className={coreStyle.paper}>
                <EmailContact onCloseModal={() => setInitialValues({})} initialValues={initialValues}
                              resource={reportResource}/>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            rowCount={isLoading ? 0 : inspections.length}
                            headCells={headCells}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {inspections.map((inspection, index) => {
                                const title = `${inspection.buyer_name}_${inspection.shipping_date}`;
                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={index}
                                    >
                                        <TableCell>{inspection.buyer_name}</TableCell>
                                        <TableCell>{inspection.shipping_date}</TableCell>
                                        <TableCell>{inspection.count}</TableCell>
                                        <TableCell>{inspection?.emails_sent}</TableCell>
                                        <TableCell>
                                            <Link
                                                to={`/reports/flowers/buyer/view?buyerId=${inspection.buyer_id}&shippingDate=${inspection.shipping_date}&title=${window.btoa(title)}`}>
                                                <button className='button-edit-delete'>
                                                    <Translate id="TABLE.ACTIONS.VIEW"/>
                                                </button>
                                            </Link>
                                            <em className='actions-separator'>|</em>
                                            <Link to="#">
                                                <button className='button-edit-delete'
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            getDownloadLink(inspection, inspection.shipping_date);
                                                        }}>
                                                    <Translate id="TABLE.ACTIONS.DOWNLOAD"/>
                                                </button>
                                            </Link>
                                            {inspection.buyer_email &&
                                            <>
                                                <em className='actions-separator'>|</em>
                                                <button className='button-edit-delete'
                                                        onClick={() => openModal(inspection)}>
                                                    <Translate id="TABLE.ACTIONS.EMAIL"/>
                                                </button>
                                            </>
                                            }

                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
